// External pakcages
import * as React from 'react';

// Components
import { SelectField, SelectFieldProps, Option } from 'components/Select';

// Hooks
import { useGetPlaces } from 'api/place';

// Types
import { Place } from '../../../server/src/types/place.types';

export const PlaceSelectField: React.FC<
  Omit<SelectFieldProps, 'children' | 'items'>
> = (props) => {
  const { data: places } = useGetPlaces();

  return (
    <SelectField items={places} {...props} isDisabled={!places?.length}>
      {places.map((item: Place) => (
        <Option key={item.id} id={item.id}>
          {item.name}
        </Option>
      ))}
    </SelectField>
  );
};
